import React from "react";
import Files from 'react-files';
import './FileUpload.css';
import Image_of_uploader from '../../assets/img/img_upload/upload.svg'
import {Button as SementicBtn, Icon} from "semantic-ui-react";
import $ from "jquery";
import * as common from "../../const/Common/CommonFunc";

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });
}

class FileUpload extends React.Component {

  state = {
    f: ""
  };

  convertToBase64 = (file) => {
    var selectedFile = file;
    if (selectedFile.length > 0) {
      var fileToLoad = selectedFile[0];
      var fileReader = new FileReader();
      let base64 = "";
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
      };
      fileReader.readAsDataURL(fileToLoad);
      return base64;
    }
  }

  handleFileChange = file => {
    var filex = file;
    file = file[0];
    const urlArray = [];
    let reader = new FileReader();
    // let file = e.target.files[0];
    //
    // if (file !== undefined) {
    //   reader.onloadend = () => {
    //     this.setState({
    //       file: file
    //       // imagePreviewUrl: reader.result
    //     });
    //   };
    // reader.readAsDataURL(file);
    // urlArray.push(reader);
    // this.props.fileUploaderHandler(file);
    // const blob = new Blob([file],{type: '.pdf'});
    // let bfile = this.convertToBase64(filex);



    if(file !== undefined) {
      if(file.size <= 52428800) {
        let base64 = "";
        getBase64(file).then(res => {
          base64 = res;
          // let formData = new FormData();
          // formData.append("file", file);
          this.props.getFile(file, file.name, "");
        });
      } else {
        common.notifyMessage("Maximum size of brochure or attachment is 50MB.");
      }
    } else {
      common.notifyMessage("Invalid file type. Please, upload .pdf file.");
    }
  }

  openInNewWindow = () => {
    // window.location.href = this.props.blink;
    window.open(this.props.blink, '_blank');
  }


  /**
   * this function use for make click for file uploader input when file upload specific btn
   * when visible in updateing process. it only visible when this.props.preview !== ""
   */
  ct = () => {
    $('.class2>div>input')[0].click()
  }

  render() {

    let file = [];
    let view = <img key={"x1"} src={Image_of_uploader} width='70px'/>;

    view =  <div style={{marginTop: "12%"}}>
              <span style={{background: '#eceff1', color: 'white', padding: '50px'}}>pdf</span>
            </div>;

    if (this.props.preview.length !== 0) {

      file.push(this.props.preview[0]);
      // view = <img key={file[0].preview.id} src={file[0].preview.url} width='100px'/>
      view = <div style={{width: '100%', height: '100%', background: 'gray', color: 'white'}}>PDF</div>

    }

    view = <div style={{width: "100%", textAlign: "center", color: "#616161", position: "relative"}}>
      {
        this.props.preview === "" ?
          <i className="circular huge icons" style={{
            display: "block", position: "relative",
            margin: "auto",
            top: "0px",
            bottom: "0"
          }}>
            <i className="file pdf icon"></i>
          </i> : <i className="circular large icons" style={{
            display: "block", position: "relative",
            margin: "auto",
            top: "0px",
            bottom: "0"
          }}>
            <i className="file pdf icon"></i>
          </i>
      }
      <span>{this.props.preview}</span>
    </div>;

    let style = "files2";
    if (this.props.fileStyle !== "file2") {
      style = "files1";
    }

    return (
      <div className={"class1"} style={{marginBottom: "40px"}}>

        <div className={"class2"}>

          <Files
            className={style}
            id={"kjadksj"}
            onChange={this.handleFileChange}
            onError={this.props.onFilesError}
            accepts={['.pdf', '.png', '.jpg']}
            multiple={false}
            maxFileSize={10000000}
            minFileSize={0}
            clickable
            disabled={true}>
            <div className="viewImage">{view}</div>
            {
              this.props.blink !== "" ?
                <div className={"pdfShowBtn"}>
                  <SementicBtn
                    className={""}
                    style={{
                      background: "rgba(11, 11, 177, 0)"
                    }}
                    // style={{position:"absolute", marginTop:"-100px", marginLeft:"-38px"}}
                    circular icon='eye' onClick={this.openInNewWindow}/>
                  <SementicBtn
                    className={"shadow"}
                    // style={{position:"absolute", marginTop:"-100px", marginLeft:"-38px"}}
                    circular icon='upload' color='blue'
                    // onClick={this.ct}
                  />
                </div>
                : ""
            }
          </Files>

          {
            this.props.blink !== "" ?
              <SementicBtn
                className={"shadow view-btn-123"}
                style={{
                  position: "absolute",
                  marginTop: "-79px",
                  marginLeft: "-43px"
                }}
                // style={{position:"absolute", marginTop:"-100px", marginLeft:"-38px"}}
                circular icon='eye' onClick={this.openInNewWindow}/>:null
          }
          {/*{*/}
            {/*this.props.blink !== "" ?*/}
              {/*<div className={"pdfShowBtn"}>*/}
                {/*<SementicBtn*/}
                  {/*className={"shadow"}*/}
                  {/*// style={{position:"absolute", marginTop:"-100px", marginLeft:"-38px"}}*/}
                  {/*circular icon='eye' onClick={this.openInNewWindow}/>*/}
                {/*<SementicBtn*/}
                  {/*className={"shadow"}*/}
                  {/*// style={{position:"absolute", marginTop:"-100px", marginLeft:"-38px"}}*/}
                  {/*circular icon='upload' color='blue' onClick={this.ct}/>*/}
              {/*</div>*/}
              {/*: ""*/}
          {/*}*/}

        </div>

      </div>

    );
  }

}

var cw = $('.files').width();
$('.files').css({'height': cw + 'px'});

export default FileUpload;
